"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DidYouKnow = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const React = __importStar(require("react"));
const character_man_builder_svg_1 = __importDefault(require("./92b3b47/assets/character-man-builder.svg"));
const paintbrush_ladder_svg_1 = __importDefault(require("./92b3b47/assets/paintbrush-ladder.svg"));
const InfoPanel_1 = require("./InfoPanel");
const PaddingWrapper = styled_1.default.div `
	padding: 1.5rem;
	display: flex;
`;
const Image = styled_1.default.img `
	height: 3.5rem;
`;
const Content = styled_1.default.div((props) => (Object.assign(Object.assign({}, merlin_theme_1.default.typography.b1), { color: props.colour, display: 'flex', flexDirection: 'column', marginLeft: '1.5rem' })));
const colourLookup = {
    purple: {
        background: merlin_theme_1.default.palette.purple.tint,
        text: merlin_theme_1.default.palette.purple.dark,
        image: paintbrush_ladder_svg_1.default,
    },
    yellow: {
        background: merlin_theme_1.default.palette.yellow.tint,
        text: merlin_theme_1.default.palette.greyscale.darker,
        image: character_man_builder_svg_1.default,
    }
};
const DidYouKnow = ({ id, text, colour, icon, widthOverride }) => {
    return (React.createElement(InfoPanel_1.InfoPanel, { colour: typeof colour === 'string' ? colourLookup[colour].background : colour.background, widthOverride: widthOverride },
        React.createElement(PaddingWrapper, { "data-testid": `did-you-know-${id}` },
            React.createElement(Image, { role: "presentation", src: icon || (typeof colour === 'string' ? colourLookup[colour].image : paintbrush_ladder_svg_1.default) }),
            React.createElement(Content, { colour: typeof colour === 'string' ? colourLookup[colour].text : colour.text }, text))));
};
exports.DidYouKnow = DidYouKnow;
//# sourceMappingURL=DidYouKnow.js.map